import { useNavigate } from "react-router-dom"
import useCTX from "../hooks/useCTX"
import IconButtonHT from "./IconButtonHT"

type EditSyllabusButtonType = {
  syllabus: string,
  unit?: string,
  lesson?: string,
}

export default function EditSyllabusButton({syllabus,unit,lesson}:EditSyllabusButtonType) {
    const { user } = useCTX()
    const navigate = useNavigate()

return (
  <>
    {" "}
    {(user.roles.includes("Head Teacher") ||
      user.roles.includes("Manager")) && (
      <IconButtonHT
        icon="edit"
        onClick={() =>
          navigate(
            `/teaching/syllabus/${syllabus}${
              unit ? `/unit/${unit}` : ""
            }${lesson ? `/lesson/${lesson}` : ""}`
          )
        }
      />
    )}
  </>
);
}